import '../PatternDetails/PatternDetails.css';
import React from "react";
export default function PatternLoadFail({failMessage, failInfo}) {


    return (
        <div className="card pattern-details">
            <h1 className="card-header">{failMessage}</h1>
            <p className="card-body">{failInfo}</p>
        </div>
    );
}